<template>
    <div>
        <riderProfile :rider = "riders"></riderProfile>
    </div>
</template>
<script>

import { mapState } from 'vuex'
import riderProfile from '@/components/back-office/Rider/RiderProfiles.vue'
export default {
    components: {
        riderProfile
    },
    data: function(){
        return {
        }
    },
    mounted() {
            const path = [{
                    text: 'Select province',
                    disabled: false,
                    href:  "/weserve_admin_login/select/"
                },
                {
                    text: 'Select service',
                    disabled: false,
                    href: '/weserve_admin_login/control/' + this.$route.params.province
                }, {
                    text: 'Rider',
                    disabled: false,
                    href: '/weserve_admin_login/control/' + this.$route.params.province + '/rider/riderinhouse'
                    // href: '/weserve_admin_login/control/' + this.$route.params.province + '/rider/riderdashboard'
                }, {
                    text: 'Rider management',
                    disabled: false,
                    href: '/weserve_admin_login/control/' + this.$route.params.province + '/rider/riderinhouse'
                }, {
                    text: 'Rider detail',
                    disabled: true,
                }
            ]
            this.$store.commit("backOffice/saveRecentRoute", path);
  },
  created() {
      this.$store.dispatch('fetchRiderListBack/getRiderDetails',this.$route.params.id)
  },
  computed: {
    ...mapState({
      riders: state => state.fetchRiderListBack.rider
    })
  }
}
</script>

